import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { FuseTranslationLoaderService } from 'app/services/translation-loader.service';
import { locale as addrEnglish } from '../addresses/i18n/en';
import { locale as addrFrench } from '../addresses/i18n/fr';
import { locale as english } from './i18n/en';
import { locale as french } from './i18n/fr';
import { SubscriptionState } from './store/subscription';
import { SubscriptionFarpOdqRoutingModule } from './subscription-farpodq.routing';
import { SubscriptionFormModule } from './subscription-form/subscription-form.module';
import { SubscriptionPeriodSelectionModule } from './subscription-period-selection/subscription-period-selection.module';

@NgModule({
  imports: [
    CommonModule,
    SubscriptionFarpOdqRoutingModule,
    TranslateModule.forChild(),
    SubscriptionFormModule,
    SubscriptionPeriodSelectionModule,
    NgxsModule.forFeature([SubscriptionState]),
  ],
})
export class SubscriptionFarpOdqModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
    translationLoader.loadTranslations(addrEnglish, addrFrench);
  }

}
